import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import { get } from "lodash";

import CloseIcon from "../Common/CloseIcon";
import images from "../../assets/img/images";

const styles = {
    mainContent: {
        width: "330px",
        minHeight: 0,
        margin: "12px",
        padding: "12px",
    },
    close: {
        background: "none",
        '&:hover': {
            background: "blue",
        },
    },
    closeIcon: {
        display: "flex",
        justifyContent: "flex-end",
    },
    center_check: {
        width: "24px",
        height: "24px",
        display: "table",
        margin: "0 auto",
    },
    center: {
        display: "table",
        margin: "0 auto",
    },
    buttons: {
        top: "20px",
        paddingBottom: "24px"
    }
};

const ConfirmOrder = (props) => {
    const { classes, handleClose } = props;

    return (
        <>
            {false ?
                <Grid
                    container
                    direction="column"
                    wrap="nowrap"
                    className={classes.mainContent}
                >
                    <Grid item xs={2} className={classes.closeIcon} style={{ position: "relative", height: "0px", left: 260, top: -8 }}>
                        <CloseIcon closeFunction={handleClose} />
                    </Grid>
                    <div className={classes.center}>
                        <img className={classes.center_check} src={images.errorIcon} alt="errorIcon" /><br />
                        <span style={{ fontSize: 16 }}>Order Failed</span>

                        <div className={classes.buttons}>
                            <Button color="primary" onClick={() => props.history.push(`/wms/requests_orders/orders`)} className={classes.center}><span style={{ fontSize: 16 }}>{I18n.get("view_order")}</span></Button>
                            <Button color="primary" onClick={handleClose} className={classes.center}><span style={{ fontSize: 16 }}>{I18n.get("site_close").toUpperCase()}</span></Button>
                        </div>
                    </div>
                </Grid>
                :
                <Grid
                    container
                    direction="column"
                    wrap="nowrap"
                    className={classes.mainContent}
                >
                    <Grid item xs={2} className={classes.closeIcon} style={{ position: "relative", height: "0px", left: 260, top: -8 }}>
                        <CloseIcon closeFunction={handleClose} />
                    </Grid>
                    <div className={classes.center}>
                        <span style={{ fontSize: 16 }}>{I18n.get("order_submit")}</span>
                        <div className={classes.buttons}>
                            <Button color="primary" onClick={() => props.history.push(`/wms/requests_orders/orders`)} className={classes.center}><span style={{ fontSize: 16 }}>{I18n.get("view_order")}</span></Button>
                            <Button color="primary" onClick={handleClose} className={classes.center}><span style={{ fontSize: 16 }}>{I18n.get("site_close").toUpperCase()}</span></Button>
                        </div>
                    </div>
                </Grid>
            }
        </>
    );
};



const mapStateToProps = (state) => {
    return {
        language: get(state, ["user", "language"]),
    };
};

export default withRouter(
    connect(mapStateToProps)(withStyles(styles)(ConfirmOrder))
);
